// import * as types from '../../store/mutation-types'
// import router from '@/router'

import VendorService from './VendorService'
import VendorRoutes from './route-types'
import _cloneDeep from 'lodash/cloneDeep'
import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'

const tag = 'vendor'

const state = {
  // items: [],
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: []
}

const getters = {
  // items: (state) => state.items,
  // get: (state, getters) => (id) => {
  //   const item = getters.items.find(item => item.id === id)
  //   if (item) {
  //     return item.entity
  //   } else {
  //     return null
  //   }
  // },
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  }
}

const actions = {
  async getStoreItem({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await VendorService.getEntity(id, ''))
    StoreUtil.setStorage(entity.id, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async editStoreItem({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await VendorService.getEntity(id, ''))
    StoreUtil.setStorage(entity.id, tag, entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(VendorRoutes.VendorListView.path, entity.id, false)
  },
  async addStoreItem({ commit }, name) {
    const entity = await VendorService.getNewEntity()
    entity.glAccount = null
    StoreUtil.setStorage(entity.id, tag, entity)
    commit('saveInitialSnapshots', entity)
    if (name) {
      const copy = _cloneDeep(entity)
      copy.name = name
      commit('saveSnapshot', copy)
    }
    StoreUtil.routeToDetail(VendorRoutes.VendorListView.path, entity.id, true)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
